module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "chapter",
    attrs: {
      "id": "toc"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_viii"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0005"
    }
  }, [_c('strong', [_vm._v("Part I: The Green Cousin")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0006"
    }
  }, [_vm._v("1: Introducing Myself")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0007"
    }
  }, [_vm._v("2: The "), _c('em', [_vm._v("Ploika")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0008"
    }
  }, [_vm._v("3: The Steamship Ticket")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0009"
    }
  }, [_vm._v("4: Uncle Hyman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0010"
    }
  }, [_vm._v("5: The Ice Cake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0011"
    }
  }, [_vm._v("6: The "), _c('em', [_vm._v("Porush")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0012"
    }
  }, [_vm._v("7: My Name")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0013"
    }
  }, [_vm._v("8: The Partners")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0014"
    }
  }, [_vm._v("9: The Green Cousin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0015"
    }
  }, [_vm._v("10: Paul Frankenthal")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0016"
    }
  }, [_vm._v("11: The Glories of Starving")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0017"
    }
  }, [_vm._v("12: The Tribe")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0018",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13: The Outside—or, What the Big Guys Did in the Lots")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0019",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14: The Haskalist")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0020",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15: Rosalind Katz and the Coo Coo Clan")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0021",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16: The Clambake")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0022",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17: Izzy")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0023",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18: Hollooeen")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0024",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19: Alienation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0025",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20: The Sauerkraut Crocks")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0026",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21: The War Alarm")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0027",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22: The Sauerkraut Crisis")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0028",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23: Mr. Winston and the Big Yoxenta")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0029",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24: Peter Quat")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0030",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25: The Five Medals")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0031",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26: Money Troubles")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0032",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27: Morris Elfenbein and the Purple Suit")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0033",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28: Biberman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0034",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29: The Bar Mitzva")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0035",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30: The Newspaper Story")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0036",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31: The Arista Meeting")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0037",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32: The Art Plates")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0038",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part II: Manhattan")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0039",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33: Golda")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0040",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34: Bernice Lavine")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0041",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35: Sde Shalom")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0042",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36: Zaideh")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0043",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37: Boss Goodkind")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0044",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38: The Yeshiva")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0045",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39: The Little Blue Books")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0046",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40: Columbia!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0047",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41: I Grow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0048",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42: Quandary")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0049",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43: I Rebel")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0050",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44: Dorsi Sabin")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0051",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45: General Lev")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0052",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46: West End Avenue")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0053",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47: Holy Joe Geiger")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0054",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48: Peter Quat at Home")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0055",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49: Dorsi in April House")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0056",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50: Holy Joe’s Temple")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0057",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51: Aunt Faiga’s Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0058",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52: “You Shall Have It”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0059",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53: Opening Night")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0060",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54: Pincus Forever")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0061",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55: Quat’s Phone Call")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0062",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56: Goldhandler")])]), _vm._v(" "), _c('p', {
    staticClass: "toc"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0063",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("Part III: April House")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0064",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57: Jazz Jacobson")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0065",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58: Mort Oshins")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0066",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59: Digging Jokes")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0067",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60: The Pirate King")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0068",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61: An Understanding Woman")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0069",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62: Goldhandler in Hollywood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0070",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63: Sandra’s Letter")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0071",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64: Johnny, Drop Your Gun")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0072",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65: Backstage at Minsky’s")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0073",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66: Grade A Showgirls")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0074",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("67: Double Trouble")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0075",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("68: “Apiece?”")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0076",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("69: I Arrive")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0077",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("70: She Arrives")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0078",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("71: Consummation")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0079",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("72: The Hemingway Pillow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0080",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("73: Lee’s Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0081",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("74: Such Sweet Sorrow")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0082",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("75: War!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0083",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("76: Bobbie’s Teeth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0084",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("77: New Girl in Town")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0085",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("78: A Moment of Truth")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0086",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("79: Bobbie’s Second Thoughts")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0087",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("80: Quat Quits")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0088",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("81: I Flee")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0089",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("82: The Recapture")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0090",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("83: Quat’s Wedding")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0091",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("84: Airlift!")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0092",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("85: Sandra Found")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0093",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("86: A Tribute of Tears")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0094",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("87: The Shoot-out")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0095",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("88: The End")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0096",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("89: The Beginning")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0097",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("90: He Will Make Peace")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0099",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Author")])]), _vm._v(" "), _c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    staticClass: "hlink",
    attrs: {
      "href": "#/Text/part0100",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Endnote")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0448d791","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/part0002.vue
// module id = 66
// module chunks = 0